/* eslint-disable react-hooks/exhaustive-deps */
import React, { ChangeEvent, useEffect, useState } from 'react';

import {
  Loading,
  Sizes,
  TextInput,
  Toggle,
} from '@sede-enterprise/shell-ds-react-framework';

import { useSelector } from 'react-redux';

import Button from '../../../../UI/Button';
import { Col, FormRow, Row } from '../../../../UI/Grid';
import { Modal } from '../../../../UI/Modal';
import { sendNotification } from '../../../../UI/Notification';
import Table from '../../../../UI/Table';
import {
  GET_UNMAPPED_SOURCE_PRODUCTION_FIELDS,
  MESSAGES,
  UPDATE_NOMINATION_VISIBILITY,
} from '../../../../constants/FieldNominations';
import { get, put } from '../../../../services/GenesisApi';
import { IFullState } from '../../../../types/All.type';
import { ITerminalMapping } from '../../../../types/FieldNominations.type';
import searchByText from '../../../../utils/searchFunction';
import { FieldNominationWrapper, ModalFooter } from '../style';
import { rolePermissions } from '../../../../constants/Permission';

interface IUnMappedMapping {
  open: boolean;
  onClose: () => void;
}

const UnMappedMapping: React.FC<IUnMappedMapping> = ({ open, onClose }) => {
  const { permissions } = useSelector(
    (state: IFullState) => state.genesisUserRolePermission
  );

  const [loadingIsVisible, setLoadingIsVisible] = useState<{
    [key: string]: boolean;
  }>({});

  const [loading, setLoading] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>('');
  const [data, setData] = useState<ITerminalMapping[]>([]);

  const getTerminalMappings = () => {
    setLoading(true);
    get(GET_UNMAPPED_SOURCE_PRODUCTION_FIELDS)
      .then((response) => {
        setData(response?.data ?? []);
      })
      .catch(() => {
        sendNotification({
          type: 'error',
          message: MESSAGES.SERVER_ERROR,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getTerminalMappings();
  }, []);

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  };

  const renderData = (text: string, mappings: ITerminalMapping[]) => {
    return searchByText(mappings, text, ['name']);
  };

  const handleSetData = (sourceProdFieldId: number, checked: boolean) => {
    setData((prevState) => {
      return prevState.map((item) => {
        if (item.id === sourceProdFieldId) {
          return {
            ...item,
            isVisible: checked,
          };
        }
        return item;
      });
    });
  };

  const handleIsVisible = (sourceProdFieldId: number, checked: boolean) => {
    setLoadingIsVisible((prevState) => ({
      ...prevState,
      [sourceProdFieldId]: true,
    }));
    put(
      `${UPDATE_NOMINATION_VISIBILITY}?sourceProductionFieldId=${sourceProdFieldId}&isVisible=${checked}`,
      {}
    )
      .then((response) => {
        sendNotification({
          type: 'success',
          message: response?.data,
        });
        setLoadingIsVisible((prevState) => ({
          ...prevState,
          [sourceProdFieldId]: false,
        }));

        handleSetData(sourceProdFieldId, checked);
      })
      .catch(() => {
        setLoadingIsVisible((prevState) => ({
          ...prevState,
          [sourceProdFieldId]: false,
        }));
        sendNotification({
          type: 'error',
          message: MESSAGES.SERVER_ERROR,
        });
      });
  };

  const renderIsVisible = (item) => {
    if (loadingIsVisible[item.id]) {
      return <Loading />;
    }
    return (
      <Toggle
        disabled={!permissions.includes(rolePermissions.updateUkNomination)}
        checked={item.isVisible}
        onChange={() => handleIsVisible(item.id, !item.isVisible)}
        data-testid={`toggle-${item.id}`}
      />
    );
  };

  const columns = [
    {
      accessKey: 'name',
      fieldName: 'name',
      title: 'Source Production Field',
      sorting: true,
    },
    {
      accessKey: 'isVisible',
      title: 'Is Visible',
      render: (row) => renderIsVisible(row),
    },
  ];

  const renderFooter = () => (
    <ModalFooter>
      {/* <Button onClick={onClose} loading={loading} disabled={loading}>
        Yes
      </Button> */}
      <Button variant='outlined' onClick={onClose}>
        Cancel
      </Button>
    </ModalFooter>
  );

  return (
    <Modal
      open={open}
      size={Sizes.Medium}
      onClose={onClose}
      title='Unmapped Source Production Fields Mapping'
      isDraggable
      maskClosable={false}
      footer={renderFooter()}
      width='60%'
    >
      <FieldNominationWrapper>
        <Row>
          <Col size={12}>
            <FormRow>
              <Col size={3} className='date-range'>
                <TextInput placeholder='Search' onChange={handleSearch} />
              </Col>
            </FormRow>
            <FormRow className='table-container'>
              <Col size={12} className='unmapped_table_container'>
                <Table
                  isLoading={loading}
                  columns={columns}
                  data={renderData(searchText, data)}
                  recordsPerPage={20}
                />
              </Col>
            </FormRow>
          </Col>
        </Row>
      </FieldNominationWrapper>
    </Modal>
  );
};

export default UnMappedMapping;
